import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import {
    HiOutlineX,
    HiOutlinePaperAirplane,
    HiOutlineClipboardCheck,
    HiOutlineCheckCircle,
    HiOutlineArrowLeft,
    HiOutlineDocumentAdd,
    HiOutlineTrash,
} from "react-icons/hi";
import { useState } from "react";
import { sendQuote } from "API";
import { markQuoteRequestCompleted, markQuoteRequestInspection } from "API/quoteRequests.api";

const QuoteRequestModal = ({ open, onClose, data, refresh }) => {
    console.log(process.env.REACT_APP_STORAGE_URL+"/"+data.quote_file)
    const client = data?.client || {};
    const vehicle = data?.vehicle || {};

    const [view, setView] = useState("modalView");
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");

    const vehicleText = `${vehicle.year} ${vehicle.make} ${vehicle.model} `


    // File Handler functionss
    const onPickFile = (e) => {
        const f = e.target.files?.[0] || null;
        setFile(f);
    };

    const clearFile = () => {
        setFile(null);
    };

    // View Handler functions

    const resetSendQuote = () => {
        setView("modalView");
        setFile(null);
        setMessage("");
    };

    const handleClose = () => {
        resetSendQuote();
        onClose();
    };

    const handleSendQuoteClick = () => {
        setView("sendQuote");
    };



    // API Call funcitons
    const markQuoteComplete = async (id) => {
        const response = true;  // await completeQuote(id);
        if (response) {
            markQuoteRequestCompleted(id);
            // Alert Part hereee
            refresh();
            onClose();
        }
    }

    const sendInspectionRequest = async (data) => {
        // Below remove true value and uncomment teh function 
        const response = true; // await requestInspection(data);
        if (response) {
            markQuoteRequestInspection(data)
            refresh();
            onClose();
        }
    }

    const handleSend = async () => {
        const payload = {
            quoteId: data.id,
            quoteReference: data.quoteReference,
            client,
            vehicle,
            vehicleText,
            message,
            file,
        };

        console.log("Data Fetched:", payload);

        const response = await sendQuote(payload);

        if (response?.ok) {
            handleClose();
            refresh()

        }
        // uncomment above line and remove below lines for API integration.
        sendQuote(payload);
        handleClose();
        refresh();

    };

    //   This line to disable the send button
    const canSend = !!file;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle sx={{ p: 2 }}>
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <span className="text-lg font-semibold text-gray-900">Quote Request</span>
                        {data?.quoteReference ? (
                            <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
                                {data.quoteReference}
                            </span>
                        ) : null}
                    </div>

                    <IconButton onClick={onClose} aria-label="close">
                        <HiOutlineX />
                    </IconButton>
                </div>
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ p: 2 }}>

                {view === "modalView" ? (
                    <>

                        <div className="grid gap-4 md:grid-cols-2">
                            {/* client */}
                            <div className="rounded-2xl border border-gray-200 bg-white p-4">
                                <h3 className="text-sm font-semibold text-gray-900">client</h3>

                                <div className="mt-3 space-y-2 text-sm">
                                    <div className="flex items-start justify-between gap-3">
                                        <span className="text-gray-500">Name</span>
                                        <span className="font-medium text-gray-900">{client.name || "—"}</span>
                                    </div>

                                    <div className="flex items-start justify-between gap-3">
                                        <span className="text-gray-500">Phone Number</span>
                                        <span className="font-medium text-gray-900">{client.phone || "—"}</span>
                                    </div>
                                    <div className="flex items-start justify-between gap-3">
                                        <span className="text-gray-500">Email</span>
                                        <span className="font-medium text-gray-900">{client.email || "—"}</span>
                                    </div>
                                </div>
                            </div>


                            <div className="rounded-2xl border border-gray-200 bg-white p-4">
                                <h3 className="text-sm font-semibold text-gray-900">Vehicle</h3>

                                <div className="mt-3 space-y-2 text-sm">
                                    <div className="flex items-start justify-between gap-3">
                                        <span className="text-gray-500">Year</span>
                                        <span className="font-medium text-gray-900">{vehicle.year || "—"}</span>
                                    </div>

                                    <div className="flex items-start justify-between gap-3">
                                        <span className="text-gray-500">Make</span>
                                        <span className="font-medium text-gray-900">{vehicle.make || "—"}</span>
                                    </div>

                                    <div className="flex items-start justify-between gap-3">
                                        <span className="text-gray-500">Model</span>
                                        <span className="font-medium text-gray-900">{vehicle.model || "—"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="mt-4 rounded-2xl border border-gray-200 bg-white p-4">
                            <h3 className="text-sm font-semibold text-gray-900">Description</h3>
                            <p className="mt-2 text-sm leading-relaxed text-gray-700">
                                {data?.message || "—"}
                            </p>
                        </div>

                        <div className="mt-5 flex flex-wrap items-center justify-end gap-2">


                            {/* Aaction Buttons for the Modal */}

                            {data.status === "received" && (
                                <>
                                    <button onClick={handleSendQuoteClick} className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700">
                                        <HiOutlinePaperAirplane className="text-base" />
                                        Send Quote
                                    </button>

                                    <button onClick={() => {
                                        sendInspectionRequest(data.id);
                                    }} className="flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-black hover:bg-amber-600">
                                        <HiOutlineClipboardCheck className="text-base" />
                                        Request Inspection
                                    </button>

                                    <button onClick={() => { markQuoteComplete(data.id) }} className="flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700">
                                        <HiOutlineCheckCircle className="text-base" />
                                        Mark As Complete
                                    </button>
                                </>
                            )}

                            {data.status === "sent quotation" && (
                                <button
                                    onClick={() => window.open(process.env.REACT_APP_STORAGE_URL+"/"+data.quote_file, '_blank', 'noopener,noreferrer')}
                                    className="flex items-center gap-2 rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-black hover:bg-blue-600"
                                >
                                    <HiOutlineClipboardCheck className="text-base" />
                                    View Quote
                                </button>
                            )}

                            {data.status === "inspection requested" && (
                                <button className="flex items-center gap-2 rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-black hover:bg-blue-600">
                                    <HiOutlineClipboardCheck className="text-base" />
                                    View Appointment
                                </button>
                            )}

                        </div>
                    </>) :
                    // Send Quote View Stats here 
                    (
                        <>
                            <button
                                onClick={() => { resetSendQuote() }}
                                className="mb-4 inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-gray-900"
                            >
                                <HiOutlineArrowLeft className="text-base" />
                                Back to details
                            </button>

                            {/* Summary */}
                            <div className="rounded-2xl border border-gray-200 bg-white p-4">
                                <div className="flex flex-wrap items-center justify-between gap-2">
                                    <div>
                                        <p className="text-sm font-semibold text-gray-900">
                                            Sending quote to {client.name || "client"}
                                        </p>
                                        <p className="mt-1 text-sm text-gray-600">
                                            {data?.quoteReference ? `Ref: ${data.quoteReference}` : ""}{" "}
                                            {vehicleText ? `• ${vehicleText}` : ""}
                                        </p>
                                    </div>

                                    <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
                                        Upload PDF Quote
                                    </span>
                                </div>
                            </div>

                            {/* Upload */}
                            <div className="mt-4 rounded-2xl border border-gray-200 bg-white p-4">
                                <h3 className="text-sm font-semibold text-gray-900">
                                    Quote File
                                </h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Upload a PDF file to send to the client.
                                </p>

                                <div className="mt-3">
                                    {/* File Not uploaded view*/}
                                    {!file ? (
                                        <label className="flex cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 px-4 py-8 text-center hover:bg-gray-100">
                                            <HiOutlineDocumentAdd className="text-3xl text-gray-500" />
                                            <p className="mt-2 text-sm font-medium text-gray-900">
                                                Click to upload
                                            </p>
                                            <p className="mt-1 text-xs text-gray-600">
                                                PDF only (recommended)
                                            </p>
                                            <input
                                                type="file"
                                                accept="application/pdf"
                                                onChange={onPickFile}
                                                className="hidden"
                                            />
                                        </label>
                                    ) :
                                        // FIle uploaded View 
                                        (
                                            <div className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3">
                                                <div className="min-w-0">
                                                    <p className="truncate text-sm font-medium text-gray-900">
                                                        {file.name}
                                                    </p>
                                                    <p className="text-xs text-gray-600">
                                                        {(file.size / 1024).toFixed(1)} KB
                                                    </p>
                                                </div>

                                                <button
                                                    onClick={clearFile}
                                                    className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                                                >
                                                    <HiOutlineTrash className="text-base" />
                                                    Remove
                                                </button>
                                            </div>
                                        )}
                                </div>
                            </div>

                            {/* Message */}
                            <div className="mt-4 rounded-2xl border border-gray-200 bg-white p-4">
                                <h3 className="text-sm font-semibold text-gray-900">
                                    Message (optional)
                                </h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Add a short note that will be sent with the quote.
                                </p>

                                <textarea
                                    rows={4}
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Hi! Please find the quote attached. Let us know if you have any questions..."
                                    className="mt-3 w-full resize-none rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                                />
                            </div>

                            {/* Send Actions */}
                            <div className="mt-5 flex flex-wrap items-center justify-end gap-2">
                                <button
                                    onClick={resetSendQuote}
                                    className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleSend}
                                    disabled={!canSend}
                                    className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium ${canSend
                                        ? "bg-blue-600 text-white hover:bg-blue-700"
                                        : "cursor-not-allowed bg-gray-200 text-gray-500"
                                        }`}
                                >
                                    <HiOutlinePaperAirplane className="text-base" />
                                    Send Now
                                </button>
                            </div>

                        </>

                    )}


            </DialogContent>
        </Dialog>
    );
};

export default QuoteRequestModal;
